import _ from 'lodash'
import styled from '@emotion/styled'
import { ReactNode } from 'react'
import { L1IconLabelButton } from '../l1/L1Button'
import { faTrashCan, faMinus } from '@fortawesome/pro-solid-svg-icons'
import { FusionColor } from '../../../theme/FusionStyle'
import * as CSS from 'csstype'

export const L2TabularListItemReadOnly = styled.div(({theme}) => ({
	gridColumn: 'rowstartln / rowendln',
	display: 'grid',
	gridTemplateColumns: 'subgrid',
	borderTop: `1px solid ${theme.colors.lines}`,
	alignItems: 'center',
	'> *': {
		padding: theme.spacing(1.5, 2),
	},
	fontSize: '16px',
}))

export const L2TabularListItemSummary = styled.div(({theme}) => ({
	gridColumn: 'rowstartln / rowendln',
	display: 'grid',
	gridTemplateColumns: 'subgrid',
	borderTop: `1px solid ${theme.colors.lines}`,
	alignItems: 'center',
	cursor: 'pointer',
	'> *': {
		padding: theme.spacing(1, 2),
	},
}))

const TabularListItemEditRoot = styled.div(({theme}) => ({
	gridColumn: 'rowstartln / rowendln',
	display: 'flex',
	flexDirection: 'column',
}))

const TabularListItemEditControls = styled.div(({theme}) => ({
	display: 'flex',
	flexWrap: 'wrap',
	backgroundColor: theme.colors.second,
	padding: theme.spacing(1, 0),
	'> *': {
		padding: theme.spacing(0.5, 2),
	},
}))

export const L2TabularListEditBreak = styled.div({
	width: '100%',
})

interface L2TabularListControlProps {
	minWidth?: number|CSS.Property.MinWidth,
}

export const L2TabularListControl = styled.div<L2TabularListControlProps>(({theme, minWidth = 'auto'}) => {
	if(_.isNumber(minWidth)) {
		minWidth = theme.spacing(minWidth)
	}
	return {
		display: 'flex',
		flexDirection: 'column',
		minWidth,
	}
})

export const L2TabularListControlLabel = styled.label(({theme}) => ({
	fontSize: '14px',
	color: theme.colors.inputLabel,
	marginBottom: theme.spacing(0.5),
}))

const TabularListItemActionBar = styled.div(({theme}) => ({
	padding: theme.spacing(0, 2),
	backgroundColor: theme.colors.third,
	color: theme.colors.blueMain,
	fontSize: '14px',
	fontWeight: 600,
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'flex-end',
	columnGap: theme.spacing(1.5),
}))

interface L2TabularListItemEditProps {
	onCloseClick?: () => void,
	onDeleteClick?: () => void,
	children?: ReactNode,
}

export const L2TabularListItemEdit = ({onCloseClick, onDeleteClick, children}: L2TabularListItemEditProps) => (
	<TabularListItemEditRoot>
		<TabularListItemEditControls>
			{children}
		</TabularListItemEditControls>
		<TabularListItemActionBar>
			{onDeleteClick ? (
				<L1IconLabelButton
					icon={faTrashCan}
					label="Delete"
					color={FusionColor.StopRed}
					onClick={onDeleteClick}
				/>
			) : null}
			<L1IconLabelButton
				icon={faMinus}
				label="Collapse"
				onClick={onCloseClick}
			/>
		</TabularListItemActionBar>
	</TabularListItemEditRoot>
)

